import Block from "quill/blots/block";
import Quill from "quill";

class VideoBlotCustom extends Block {
    static blotName = 'videoEmbed';
    static tagName = 'div';
    static className = 'ql-video-embed';

    static create(value: string) {
        let node = super.create();
        node.classList.add(VideoBlotCustom.className);

        let videoElement: string = "";

        if (value.includes("youtube.com") || value.includes("youtu.be")) {
            // YouTube embed
            const videoId = this.extractYouTubeId(value);
            if (videoId) {
                videoElement = `
                <iframe 
                    width="560" 
                    height="315" 
                    src="https://www.youtube.com/embed/${videoId}" 
                    title="YouTube video player" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    allowfullscreen>
                </iframe>
            `;
            } else {
                videoElement = "Invalid YouTube URL";
            }

        } else if (value.includes("vimeo.com")) {
            const videoId = this.extractVimeoId(value);
            if (videoId) {
                videoElement = `
                <iframe 
                    src="https://player.vimeo.com/video/${videoId}" 
                    width="640" 
                    height="360"
                    allow="autoplay; fullscreen; picture-in-picture" 
                    allowfullscreen>
                </iframe>
            `;
            } else {
                videoElement = "Invalid Vimeo URL";
            }
        } else {
            videoElement = `
            <video width="640" height="360" controls>
                <source src="${value}" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        `;
        }

        node.innerHTML = videoElement;
        return node;
    }

    static value(node: HTMLElement): string | null {
        let videoURL = "";
        const iframe = node.querySelector('iframe');
        const a = node.querySelector('a');

        if (iframe) {
            try {
                if(iframe.src.includes('youtube')){
                    videoURL = this.extractYouTubeId(iframe.src) ?? "";
                } else if(iframe.src.includes('vimeo')) {
                    videoURL = this.extractVimeoId(iframe.src) ?? "";
                }
            } catch(e) {
                videoURL = "";
            }
        } else if (a) {
            videoURL =  a.href;
        }

        return videoURL;
    }

    static extractYouTubeId(url: string): string | null {
        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11) ? match[2] : null;
    }

    static extractVimeoId(url: string): string | null {
        const regExp = /^.*(vimeo\.com\/)((channels[^\/]+|groups[^\/]+)\/videos\/|)(\d+)/;
        const match = url.match(regExp);

        return match && match[4] ? match[4] : null;
    }
}


Quill.register(VideoBlotCustom);

export default VideoBlotCustom;